import React from 'react';

import {useActiveThread} from '../../agentChat/store/context';
import {AgentChatProvider, useAgentChatAvailability} from '../AgentChat';
import {WBAgentChatButton} from './WBAgentChatButton';
import {WBAgentChatDrawer} from './WBAgentChatDrawer';
import {WBAgentChatWindow} from './WBAgentChatWindow';
import {useWBAgentContextStore} from './WBAgentContextStore';

/**
 * Component tree:
 * WBAgent → WBAgentInner
 *   ├── WBAgentChatButton
 *   ├── WBAgentChatWindow (floating, undocked)
 *   │   ├── WBAgentHeader
 *   │   └── WBAgentThread
 *   └── WBAgentChatDrawer (docked)
 *       └── WBAgentHeader
 *       └── WBAgentThread
 */

export const WBAgent = () => {
  return (
    <AgentChatProvider>
      <WBAgentInner />
    </AgentChatProvider>
  );
};

export const WBAgentInner = () => {
  const {isAvailable: isWorkspaceAgentEnabled} = useAgentChatAvailability();
  const activeThread = useActiveThread();
  const open = useWBAgentContextStore(s => s.open);
  const setOpen = useWBAgentContextStore(s => s.setOpen);
  const docked = useWBAgentContextStore(s => s.docked);

  return (
    <>
      {isWorkspaceAgentEnabled && (
        <WBAgentChatButton
          onPress={() => setOpen(!open)}
          isLoading={activeThread?.status === 'running'}
        />
      )}
      {open &&
        isWorkspaceAgentEnabled &&
        (docked ? <WBAgentChatDrawer /> : <WBAgentChatWindow />)}
    </>
  );
};
